import { AxiosResponse } from "axios";
import { BodyShopFilterRequest, BodyShopSaveRequest } from "@/main/models/request/bodyshopRequest";
import {
	BodyshopRegistrationBranchResponse,
	BodyshopRegistrationDataResponse,
	BodyshopResponse,
	BodyshopSaveResponse,
} from "@/main/models/response";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

export abstract class IBodyshopApi {
	abstract getBodyshopsOrBodyshopBranchesDomain(
		request: BodyShopFilterRequest,
	): Promise<AxiosResponse<Result<KeyValue[]>>>;

	abstract getSearchGrid(request: BodyShopFilterRequest): Promise<AxiosResponse<BodyshopResponse>>;

	abstract getRegistrationDataBodyshop(
		request: BodyShopFilterRequest,
	): Promise<AxiosResponse<Result<BodyshopRegistrationDataResponse>>>;

	abstract getRegistrationDataBodyshopBranch(
		request: BodyShopFilterRequest,
	): Promise<AxiosResponse<Result<BodyshopRegistrationBranchResponse[]>>>;

	abstract saveBodyshop(request: BodyShopSaveRequest): Promise<AxiosResponse<Result<BodyshopSaveResponse>>>;
}
